import { render } from "./NewUpdateForm.vue?vue&type=template&id=dae75fcc&scoped=true"
import script from "./NewUpdateForm.vue?vue&type=script&lang=js"
export * from "./NewUpdateForm.vue?vue&type=script&lang=js"

import "../styles/UpdateProfile.scss?vue&type=style&index=0&id=dae75fcc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dae75fcc"]])

export default __exports__